import React, { useState } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'
import { Col, Row, Label, Input, Button, Modal, ModalHeader, ModalBody } from 'reactstrap'
import { useSelector } from 'react-redux'
import { Switch } from '../../../components/Inputs/Input'
import Select from '../../../components/Inputs/Select'
import * as actions from '../../../store/modules/comissao/actions'
import { getTipoComissaoBancoId } from '../../../controllers/comissaoController'

const CardItem = ({ e, i }) => {

    const { tiposComissaoBanco, registros, seeRegister } = useSelector(state => state.comissao)

    const [modalRemover, setModalRemover] = useState(false)

    function toggleModalRemover() {
        setModalRemover(!modalRemover)
    }

    function handleRemoverItem() {
        actions.setRegistros({
            ...registros,
            tabelaComissaoEventos: registros.tabelaComissaoEventos.filter((_, index) => index !== i)
        })
        setModalRemover(false)
    }

    return (
        <div className='p-3 mt-2' style={{ width: '100%', borderRadius: '5px', border: '1px solid #CCCFDE' }}>
            <Modal
                className='text-center'
                isOpen={modalRemover}
                toggle={toggleModalRemover}
                backdrop={false}
            >
                <ModalHeader toggle={toggleModalRemover} style={{ height: '10px', border: 'none' }} />
                <ModalBody>
                    <p style={{ fontSize: '18px', color: 'var(--color-preto)' }}>
                        Tem certeza que deseja <strong style={{ fontSize: '17px' }}>remover</strong> esse evento?
                    </p>
                    {e.id &&
                        <p style={{ fontSize: '14px', color: 'var(--color-cinza-medio)' }}>
                            A exclusão só será gravada ao clicar em Salvar Cadastro.
                        </p>
                    }
                </ModalBody>
                <div className='m-3'>
                    <Button
                        onClick={() => toggleModalRemover()}
                        color='danger'
                        style={{ width: '100px', marginRight: '15px' }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => handleRemoverItem()}
                        style={{ width: '100px', marginLeft: '15px', background: 'var(--color-verde)', border: 'none' }}
                    >
                        Confirmar
                    </Button>
                </div>
            </Modal>
            <Row style={{ marginRight: '-200px' }}>
                <Col md={4}>
                    <Label style={{ fontWeight: '700', color: 'var(--color-preto)' }}>Tipo de comissão</Label>
                    <Select
                        value={getTipoComissaoBancoId(e)}
                        label='descricao'
                        options={tiposComissaoBanco}
                        disabled
                    />
                </Col>
                <Col md={1}>
                    <Label style={{ fontWeight: '700', color: 'var(--color-preto)' }}>Meses de</Label>
                    <Input
                        type='text'
                        value={e.mesesDe}
                        disabled
                    />
                </Col>
                <Col md={1}>
                    <Label style={{ fontWeight: '700', color: 'var(--color-preto)' }}>Meses até</Label>
                    <Input
                        type='text'
                        value={e.mesesAte}
                        disabled
                    />
                </Col>
                <Col md={1.1}>
                    <Label style={{ fontWeight: '700', color: 'var(--color-preto)' }}>{e.unidade === 'UNIDADE' ? 'Unidade' : 'Percentual'}</Label>
                    <Input
                        type='text'
                        value={e.valor}
                        disabled
                        style={{ width: '110px' }}
                        maxLength={e.unidade === 'UNIDADE' ? '12' : '6'}
                    />
                </Col>
                <Col md={2}>
                    <Label style={{ fontWeight: '700', color: 'var(--color-preto)', paddingTop: '20px' }}>Impede Repasse</Label>
                    <Switch
                        className='switch mt-4'
                        checked={e.impedeRepasse}
                    />
                </Col>

                {
                    !seeRegister ?
                        <>
                            <AiOutlineCloseCircle
                                style={{
                                    fontSize: '20px',
                                    color: 'var(--color-laranja)',
                                    marginTop: '20px',
                                    marginRight: '5px',
                                    marginLeft: '-10px',
                                    cursor: 'pointer'
                                }}
                                onClick={() => toggleModalRemover()}
                            />
                            < Label onClick={() => toggleModalRemover()} style={{ fontWeight: '700', color: 'var(--color-preto)', paddingTop: '20px', cursor: 'pointer' }}>Remover</Label>
                        </>
                        :
                        ''
                }
            </Row>
        </div >
    )
}

export default CardItem
